import { SignIn, useAuth } from "@clerk/react"
import { Navigate } from "@tanstack/react-router"

import { AuthShell } from "@/features/auth/auth-shell"

type SignInPageVariant = "default" | "fleetClient"

interface SignInPageProps {
  redirectUrl?: string
  variant?: SignInPageVariant
}

function resolveSignInFallbackRedirectUrl(
  redirectUrl: string | undefined,
  variant: SignInPageVariant
) {
  if (variant === "fleetClient") {
    return "/fleet/onboarding/organization"
  }

  return redirectUrl ?? "/account"
}

export function SignInPage({ redirectUrl, variant = "default" }: SignInPageProps) {
  const { isSignedIn, isLoaded } = useAuth()
  const fallbackRedirectUrl = resolveSignInFallbackRedirectUrl(redirectUrl, variant)
  const isFleetClientLane = variant === "fleetClient"
  const signUpUrl = isFleetClientLane ? "/fleet-invite" : "/sign-up"

  if (isLoaded && isSignedIn) {
    return <Navigate to={fallbackRedirectUrl} replace />
  }

  return (
    <AuthShell
      title={isFleetClientLane ? "Sign in to Fleet Safety" : "Sign in to SafetyQR"}
      description={
        isFleetClientLane
          ? "Sign in to continue directly to Fleet company-details onboarding."
          : "Access your account to manage devices, view reports, and more."
      }
    >
      <SignIn
        fallbackRedirectUrl={fallbackRedirectUrl}
        path="/sign-in"
        routing="path"
        signUpUrl={signUpUrl}
      />
    </AuthShell>
  )
}
